import React from "react";
import { Inbox } from "lucide-react";

/**
 * ─── PagePlaceholder ─────────────────────────────────────────────────────
 * Page-level empty state (PDR §8 · P2). Used inside Management templates
 * when the primary collection is empty. NOT a table-row empty state — that
 * remains DataTable's built-in `emptyTitle` / `emptyDescription`.
 */
export default function PagePlaceholder({
  icon, title, description, action, testId = "page-placeholder",
}) {
  const IconEl = icon || Inbox;
  return (
    <div className="ds-placeholder" data-testid={testId}>
      <div className="ds-placeholder__icon" aria-hidden><IconEl size={22} strokeWidth={1.7} /></div>
      <div className="ds-placeholder__title">{title}</div>
      {description && <div className="ds-placeholder__desc">{description}</div>}
      {action && <div className="ds-placeholder__action">{action}</div>}
    </div>
  );
}
